// extracted by mini-css-extract-plugin
export default {"titleItem":"ItemHeaderTopWithMenu_titleItem__xLJJj"};